import React from "react"
import Featured from "../../Components/Featured/Featured"
import "./Home.css"

function Home() {
  return (
    <div className="home">
      <Featured />
    </div>
  )
}

export default Home
